import {
  type KeyFigure,
  formatNumber,
  isDefined,
  noDecimalsFormatOptions,
} from "@pharmupp/p3-front-commons"
import {
  LoyaltyProgramCard,
  type LoyaltyProgramCardProps,
} from "../../../LoyaltyProgram"

export const VisitorStatCard = ({
  keyFigure,
  ...props
}: Omit<LoyaltyProgramCardProps, "slotProps" | "value"> & {
  keyFigure?: KeyFigure
}) => {
  const value = isDefined(keyFigure?.mainStat)
    ? `${formatNumber(keyFigure?.mainStat, noDecimalsFormatOptions)} clients/jour`
    : "-"
  return (
    <LoyaltyProgramCard {...props} value={value} evolution={keyFigure?.evolution} />
  )
}
